/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

// Angular
// noinspection JSNonASCIINames,NonAsciiCharacters,RedundantIfStatementJS,JSUnusedLocalSymbols,JSUnusedGlobalSymbols,UnnecessaryLocalVariableJS,JSDeprecatedSymbols

// Material
import { SelectionModel } from '@angular/cdk/collections';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DatePipe, formatCurrency, formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {
  MatLegacyAutocomplete as MatAutocomplete,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
// NGRX
import { select, Store } from '@ngrx/store';
import { saveAs } from 'file-saver';
// LODASH
import { isEmpty, orderBy } from 'lodash';
import * as moment from 'moment';
import {
  BehaviorSubject,
  fromEvent,
  merge,
  Observable,
  of,
  Subject,
  Subscription,
} from 'rxjs';
// RXJS
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  finalize,
  last,
  map,
  skip,
  take,
  takeUntil,
  takeWhile,
  tap,
} from 'rxjs/operators';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

// Services
import {
  LayoutUtilsService,
  MessageType,
  QueryParamsModel,
} from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import {
  AllUsersLoaded,
  AuthService,
  selectUserById,
  selectUsersInStore,
  User,
  UserActionTypes,
} from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';
// Models and selectors
import {
  ActionFail,
  ActionRefresh,
  ActionSuccess,
  AError,
  CheckKgByXLS,
  CheckKgByXLS_ACS,
  CheckReturned,
  CSError,
  EError,
  FetchVoucher,
  GCActionFail,
  GCActionSuccess,
  GConfig,
  GConfigActionTypes,
  GConfigUpdate,
  GotVoucher,
  Liquidate,
  LiquidationFail,
  LiquidationSuccess,
  MarkAsApprovedByXLS_KRONOS,
  MarkAsPaidByXLS,
  MarkAsPaidByXLS_ACS,
  MarkAsPaidByXLS_CS,
  MarkAsPaidByXLS_KRONOS,
  MarkAsPaidByXLS_SPDX,
  MarkAsPaidByXLS_TAXY,
  MarkCancellationPending,
  MarkClarification,
  MarkInvoiced,
  MarkPaid,
  MarkPaidApproved,
  MarkPrepaid,
  MarkPrereturn,
  MarkProcessed,
  MarkReturned,
  MassMarkCancellationPending,
  MassMarkInvoiced,
  MassMarkPaid,
  MassMarkPaidApproved,
  MassMarkPrepaid,
  MassMarkProcessed,
  ReturnDeliveredXLS,
  ScriptService,
  selectFinancialFilters,
  selectGConfigById,
  selectLiquidationInProgress,
  selectShipmentById,
  selectUserFinancialFilters,
  SendDeliveredXLS,
  SError,
  SetFinancialFilters,
  SetUserFinancialFilters,
  Shipment,
  ShipmentActionTypes,
  ShipmentCancel,
  ShipmentCheckWeight,
  ShipmentMassCheckWeight,
  ShipmentsPageRequested,
  SWChargesDataSource,
  ToggleReturnDelivered,
  ToggleSendDelivered,
  UNFError,
  UnMarkPrepaid,
  UnMarkPrereturn,
  ValidateSPDX,
} from '../../../../../core/rex';
import { MarkAsPaidByXLS_ELTA2 } from '../../../../../core/rex/_actions/shipment.actions';
import { calculatePercentageCharges } from '../../../../../core/rex/_data-sources/swcharges.datasource';
//import * as fs from 'file-saver';
//import * as XLSX from 'xlsx';

//import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts';
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare let pdfMake: any;
declare let pdfFonts: any;

@Component({
  selector: 'kt-shipments-financial',
  templateUrl: './shipments-financial.component.html',
  styleUrls: ['./shipments-financial.component.scss'],
})
export class ShipmentsFinancialComponent implements OnInit, OnDestroy {
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;

  dataSource: SWChargesDataSource;
  displayedColumns = [
    'select',
    'recipient_name',
    'vg_code',
    '_status',
    'date_approved',
    'cod_ammount',
    'prereturn_ammount',
    'cost',
    'is_delivered',
    'actions',
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  // Filter fields
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('searchInputTel', { static: true }) searchInputTel: ElementRef;

  lastQuery: QueryParamsModel;
  // Selection
  selection = new SelectionModel<Shipment>(true, []);
  bigBucket: Array<any> = [];
  shipmentsResult: Shipment[] = [];
  adminView = false;
  serverError: Subject<any>;
  customWarning: Subject<any>;
  customInfo: Subject<any>;
  customInfo2: Subject<any>;
  customInfo3: Subject<any>;
  customInfo4: Subject<any>;
  isPrinting: BehaviorSubject<boolean>;
  curr_mask = createNumberMask({
    prefix: '€ ',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
  });
  curr_mask1 = createNumberMask({
    suffix: ' €',
    prefix: '',
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
    allowNegative: true,
  });
  extraCharges: Array<any> = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  usrCtrl = new UntypedFormControl();
  _usrCtrl = new UntypedFormControl();
  filteredOptions: Observable<User[]>;
  _ab_filteredOptions: Observable<User[]>;
  fUsers: User[] = [];
  fabUsers: User[] = [];
  fStatus: Array<string> = [
    'PROCESSED',
    'PAID',
    'PAID_APPROVED',
    'INVOICED',
    'RETURNED',
    'CANCELLATION_PENDING',
    'CANCELLED',
    'CLARIFICATION',
  ];
  fvg_codes: Array<string> = [];
  dpFA: any;
  dpTA: any;
  dpFP: any;
  dpTP: any;
  dpFI: any;
  dpTI: any;
  dpFR: any;
  dpTR: any;
  dpFSD: any;
  dpTSD: any;
  dpFRD: any;
  dpTRD: any;
  dpFAD: any;
  dpTAD: any;
  sDl = true;
  sprepaid = true;
  oprepaid = false;
  delivered = true;
  odelivered = false;
  returned = true;
  oreturned = false;
  odsr = false;
  arsr = false;
  ord = false;
  snd_del = false;
  osp = false;
  nocod = false;
  ocod = false;
  diffinvw = false;
  courier: string;
  @ViewChild('usrInput') usrInput: ElementRef<HTMLInputElement>;
  @ViewChild('_usrInput') _usrInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  // Subscriptions
  private subscriptions: Subscription[] = [];

  // Liquidation state management
  isLiquidationInProgress$ = this.store.pipe(
    select(selectLiquidationInProgress)
  );
  private pendingLiquidationFiles: {
    codFile: Blob;
    chargesFile: Blob;
    receiptFile: Blob;
    user: User;
  } | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private subheaderService: SubheaderService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private actions$: Actions,
    private auth: AuthService,
    private dp: DatePipe,
    private scriptService: ScriptService
  ) {
    this.scriptService
      .load('pdfMake')
      .then(() => this.scriptService.load('vfsFonts'));
  }

  ngOnInit() {
    if (this.router.url.startsWith('/shipment-management/admin')) {
      this.adminView = true;
      //this.store.dispatch( new AllUsersRequested());
      this.displayedColumns = [
        'select',
        'vg_code',
        '_status',
        'date_approved',
        'date_paid',
        'cod_ammount',
        'prereturn_ammount',
        'cost',
        'prepaid_ammount',
        'is_delivered',
        'actions',
      ];
    } else {
      this.adminView = false;
    }

    this.clearExtraCharges();

    this.serverError = new Subject();
    this.serverError.next(false);
    this.customWarning = new Subject();
    this.customWarning.next(false);
    this.customInfo = new Subject();
    this.customInfo.next(false);
    this.customInfo2 = new Subject();
    this.customInfo2.next(false);
    this.customInfo3 = new Subject();
    this.customInfo3.next(false);
    this.customInfo4 = new Subject();
    this.customInfo4.next(false);

    this.isPrinting = new BehaviorSubject<boolean>(false);
    this.isPrinting.next(false);

    const ss = this.actions$
      .pipe(
        ofType<ActionSuccess>(ShipmentActionTypes.ActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Delete,
            5000,
            true,
            true
          );
          this.clearSelection();
        })
      )
      .subscribe();
    this.subscriptions.push(ss);

    const sf = this.actions$
      .pipe(
        ofType<ActionFail>(ShipmentActionTypes.ActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την μεταβολή των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
          // eslint-disable-next-line no-prototype-builtins
          if (payload.result.hasOwnProperty('ref_s') && payload.result.ref_s) {
            this.loadShipmentsList();
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);

    const se = this.actions$
      .pipe(
        ofType<SError>(ShipmentActionTypes.SError),
        tap(({ payload }) => {
          this.customInfo.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(se);
    const ee = this.actions$
      .pipe(
        ofType<EError>(ShipmentActionTypes.EError),
        tap(({ payload }) => {
          this.customInfo2.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ee);
    const cse = this.actions$
      .pipe(
        ofType<CSError>(ShipmentActionTypes.CSError),
        tap(({ payload }) => {
          this.customInfo3.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(cse);
    const ae = this.actions$
      .pipe(
        ofType<AError>(ShipmentActionTypes.AError),
        tap(({ payload }) => {
          this.customInfo3.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ae);
    const unfe = this.actions$
      .pipe(
        ofType<UNFError>(ShipmentActionTypes.UNFError),
        tap(({ payload }) => {
          this.customInfo4.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ae);
    const arf = this.actions$
      .pipe(
        ofType<ActionRefresh>(ShipmentActionTypes.ActionRefresh),
        tap(({ payload }) => {
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(arf);

    // Subscribe to liquidation-specific actions
    this.actions$
      .pipe(
        ofType<LiquidationSuccess>(ShipmentActionTypes.LiquidationSuccess),
        takeUntil(this.destroy$),
        tap(() => {
          this.onLiquidationSuccess();
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType<LiquidationFail>(ShipmentActionTypes.LiquidationFail),
        takeUntil(this.destroy$),
        tap(() => {
          this.onLiquidationFailed();
        })
      )
      .subscribe();

    const sortSubscription = this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = 0)
    );
    this.subscriptions.push(sortSubscription);

    const paginatorSubscriptions = merge(
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        tap(() => {
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);

    // Filtration, bind to searchInput
    const searchSubscription = fromEvent(
      this.searchInput.nativeElement,
      'keyup'
    )
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(searchSubscription);

    const searchSubscriptionTel = fromEvent(
      this.searchInputTel.nativeElement,
      'keyup'
    )
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(searchSubscriptionTel);

    // Set title to page breadCrumbs
    this.subheaderService.setTitle('Οικονομική Διαχείριση');

    let fres: Observable<any>;
    if (this.adminView) {
      fres = this.store.pipe(select(selectFinancialFilters));
    } else {
      fres = this.store.pipe(select(selectUserFinancialFilters));
    }

    // Init DataSource
    this.dataSource = new SWChargesDataSource(this.store, this.actions$);
    const entitiesSubscription = this.dataSource.entitySubject
      .pipe(skip(1), distinctUntilChanged())
      .subscribe(res => {
        this.shipmentsResult = res;
        this.restoreSelection();
      });
    this.subscriptions.push(entitiesSubscription);

    //Action will be dispatched from datasource
    this.actions$
      .pipe(ofType<AllUsersLoaded>(UserActionTypes.AllUsersLoaded), take(1))
      .subscribe(() => {
        fres
          .pipe(
            take(1),
            tap(res => this.restore_filters(res)),
            tap(() => this.loadShipmentsList())
          )
          .subscribe();
      });
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Extra charges
  addExtraCharge() {
    this.extraCharges.push({
      id: this.guid(),
      reason: undefined,
      charge: undefined,
    });
    console.log(this.extraCharges);
  }

  removeExtraCharge(id: string) {
    this.extraCharges = this.extraCharges.filter(x => x.id != id);
  }

  clearExtraCharges() {
    this.extraCharges.splice(0, this.extraCharges.length);
    //console.log(this.extraCharges);
  }

  restore_filters(res: any) {
    if (!isEmpty(res)) {
      this.sort.direction = res.sortOrder;
      this.sort.active = res.sortField;
      this.paginator.pageIndex = res.pageNumber;
      this.paginator.pageSize = res.pageSize;

      if ('_status' in res.filter) {
        this.fStatus = [...res.filter._status];
      }

      if ('is_prepaid' in res.filter) {
        this.sprepaid = res.filter.is_prepaid;
      }

      if ('is_returned' in res.filter) {
        this.returned = res.filter.is_returned;
      }

      if ('is_delivered' in res.filter) {
        this.delivered = res.filter.is_delivered;
      }

      if ('only_prepaid' in res.filter) {
        this.oprepaid = res.filter.only_prepaid;
      }

      if ('only_returned' in res.filter) {
        this.oreturned = res.filter.only_returned;
      }

      if ('odsr' in res.filter) {
        this.odsr = res.filter.odsr;
      }

      if ('arsr' in res.filter) {
        this.arsr = res.filter.arsr;
      }

      if ('only_delivered' in res.filter) {
        this.odelivered = res.filter.only_delivered;
      }

      if ('ord' in res.filter) {
        this.ord = res.filter.ord;
      }

      if ('snd_del' in res.filter) {
        this.snd_del = res.filter.snd_del;
      }

      if ('osp' in res.filter) {
        this.osp = res.filter.osp;
      }

      if ('nocod' in res.filter) {
        this.nocod = res.filter.nocod;
      }

      if ('ocod' in res.filter) {
        this.ocod = res.filter.ocod;
      }

      if ('diffinvw' in res.filter) {
        this.diffinvw = res.filter.diffinvw;
      }

      if ('recipient_name' in res.filter) {
        this.searchInput.nativeElement.value = res.filter.recipient_name;
      }

      if ('recipient_tel' in res.filter) {
        this.searchInputTel.nativeElement.value = res.filter.recipient_tel;
      }

      if ('dpfa' in res.filter) {
        this.dpFA = moment(res.filter.dpfa);
      }

      if ('dpta' in res.filter) {
        this.dpTA = moment(res.filter.dpta);
      }

      if ('dpfp' in res.filter) {
        this.dpFP = moment(res.filter.dpfp);
      }

      if ('dptp' in res.filter) {
        this.dpTP = moment(res.filter.dptp);
      }

      if ('dpfi' in res.filter) {
        this.dpFI = moment(res.filter.dpfi);
      }

      if ('dpti' in res.filter) {
        this.dpTI = moment(res.filter.dpti);
      }

      if ('dpfr' in res.filter) {
        this.dpFR = moment(res.filter.dpfr);
      }

      if ('dptr' in res.filter) {
        this.dpTR = moment(res.filter.dptr);
      }

      if ('dpfsd' in res.filter) {
        this.dpFSD = moment(res.filter.dpfsd);
      }

      if ('dptsd' in res.filter) {
        this.dpTSD = moment(res.filter.dptsd);
      }

      if ('dpfrd' in res.filter) {
        this.dpFRD = moment(res.filter.dpfrd);
      }

      if ('dptrd' in res.filter) {
        this.dpTRD = moment(res.filter.dptrd);
      }

      if ('dpfad' in res.filter) {
        this.dpFAD = moment(res.filter.dpfad);
      }

      if ('dptad' in res.filter) {
        this.dpTAD = moment(res.filter.dptad);
      }

      if ('uids' in res.filter) {
        res.filter.uids.forEach(uid => {
          this.store
            .pipe(
              select(selectUserById(uid)),
              take(1),
              tap(res => this.fUsers.push(res))
            )
            .subscribe();
        });
      }

      if ('_ab_uids' in res.filter) {
        res.filter._ab_uids.forEach(uid => {
          this.store
            .pipe(
              select(selectUserById(uid)),
              take(1),
              tap(res => this.fabUsers.push(res))
            )
            .subscribe();
        });
      }

      if ('vg_codes' in res.filter) {
        this.fvg_codes = [...res.filter.vg_codes];
      }

      if ('courier' in res.filter) {
        this.courier = res.filter.courier;
      }

      this.cdr.detectChanges();
    } else {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 50;
      this.sort.active = 'date_created';
      this.sort.direction = 'desc';
    }
  }

  //Filter shit here

  clearFilters() {
    if (this.adminView) {
      this.store.dispatch(new SetFinancialFilters({ filters: {} }));
    } else {
      this.store.dispatch(new SetUserFinancialFilters({ filters: {} }));
    }

    const url = this.router.url;
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl(url));
  }

  vg_add(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.fvg_codes.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  vg_remove(code: string) {
    const index = this.fvg_codes.indexOf(code);
    if (index >= 0) {
      this.fvg_codes.splice(index, 1);
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  filterUsers(event) {
    const val = event.target.value;
    this.filteredOptions = this._filter(val);
  }

  _ab_filterUsers(event) {
    const val = event.target.value;
    this._ab_filteredOptions = this._ab_filter(val);
  }

  _filter(val: any): Observable<User[]> {
    if (typeof val === 'object') {
      return of(null);
    } else {
      return this.store.pipe(
        select(selectUsersInStore),
        map(res => res.items),
        map((res: Array<User>) => res.filter((usr: User) => usr.id != 1)),
        map((res: Array<User>) =>
          res.filter((usr: User) => !this.fUsers.some(el => el.id === usr.id))
        ),
        map((res: Array<User>) =>
          res.filter(
            (usr: User) =>
              usr.id == val ||
              usr.kap == val ||
              usr.firstname.match(new RegExp(val, 'i')) ||
              usr.lastname.match(new RegExp(val, 'i')) ||
              usr.email.match(new RegExp(val, 'i'))
          )
        ),
        take(1),
        map(res => orderBy(res, ['id'], ['asc']))
      );
    }
  }

  _ab_filter(val: any): Observable<User[]> {
    if (typeof val === 'object') {
      return of(null);
    } else {
      return this.store.pipe(
        select(selectUsersInStore),
        map(res => res.items),
        map((res: Array<User>) => res.filter((usr: User) => usr.id != 1)),
        map((res: Array<User>) =>
          res.filter((usr: User) => !this.fabUsers.some(el => el.id === usr.id))
        ),
        map((res: Array<User>) =>
          res.filter(
            (usr: User) =>
              usr.id == val ||
              usr.kap == val ||
              usr.firstname.match(new RegExp(val, 'i')) ||
              usr.lastname.match(new RegExp(val, 'i')) ||
              usr.email.match(new RegExp(val, 'i'))
          )
        ),
        take(1),
        map(res => orderBy(res, ['id'], ['asc']))
      );
    }
  }

  refs(): void {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  courierChange($event) {
    this.loadShipmentsList();
  }

  remove(usr: User): void {
    const index = this.fUsers.indexOf(usr);
    if (index >= 0) {
      this.fUsers.splice(index, 1);
      this.filteredOptions = this._filter('');
      this.paginator.pageIndex = 0;
      this.clearSelection();
      this.clearExtraCharges();
      this.loadShipmentsList();
    }
  }

  _ab_remove(usr: User): void {
    const index = this.fabUsers.indexOf(usr);
    if (index >= 0) {
      this.fabUsers.splice(index, 1);
      this._ab_filteredOptions = this._ab_filter('');
      this.paginator.pageIndex = 0;
      this.clearSelection();
      this.loadShipmentsList();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.fUsers.push(event.option.value);
    this.usrInput.nativeElement.value = '';
    this.usrCtrl.setValue(null);
    this.paginator.pageIndex = 0;
    this.clearSelection();
    this.clearExtraCharges();
    this.loadShipmentsList();
  }

  _ab_selected(event: MatAutocompleteSelectedEvent): void {
    this.fabUsers.push(event.option.value);
    this._usrInput.nativeElement.value = '';
    this._usrCtrl.setValue(null);
    this.paginator.pageIndex = 0;
    this.clearSelection();
    this.loadShipmentsList();
  }

  prepStatusChanged(event) {
    if (event.source._checked) {
      this.sprepaid = true;
    } else {
      this.sprepaid = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oprepStatusChanged(event) {
    if (event.source._checked) {
      this.oprepaid = true;
    } else {
      this.oprepaid = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  deliveredStatusChanged(event) {
    if (event.source._checked) {
      this.delivered = true;
    } else {
      this.delivered = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  odeliveredStatusChanged(event) {
    if (event.source._checked) {
      this.odelivered = true;
    } else {
      this.odelivered = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  returnedStatusChanged(event) {
    if (event.source._checked) {
      this.returned = true;
    } else {
      this.returned = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oreturnedStatusChanged(event) {
    if (event.source._checked) {
      this.oreturned = true;
    } else {
      this.oreturned = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  odsrStatusChanged(event) {
    if (event.source._checked) {
      this.odsr = true;
    } else {
      this.odsr = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  arsrStatusChanged(event) {
    if (event.source._checked) {
      this.arsr = true;
    } else {
      this.arsr = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  ordStatusChanged(event) {
    if (event.source._checked) {
      this.ord = true;
    } else {
      this.ord = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  sendDeliveredStatusChanged(event) {
    if (event.source._checked) {
      this.snd_del = true;
    } else {
      this.snd_del = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  ospStatusChanged(event) {
    if (event.source._checked) {
      this.osp = true;
    } else {
      this.osp = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  nocodStatusChanged(event) {
    if (event.source._checked) {
      this.nocod = true;
    } else {
      this.nocod = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oCodStatusChanged(event) {
    if (event.source._checked) {
      this.ocod = true;
    } else {
      this.ocod = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  withDiffInvWeight(event) {
    if (event.source._checked) {
      this.diffinvw = true;
    } else {
      this.diffinvw = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  fStatusChanged(event) {
    if (event.source._checked) {
      this.fStatus = [...this.fStatus, event.value];
    } else {
      this.fStatus = this.fStatus.filter(e => e !== event.value);
    }

    if (!this.adminView && event.value === 'PROCESSED') {
      if (event.source._checked) {
        this.fStatus = [...this.fStatus, 'PAID'];
      } else {
        this.fStatus = this.fStatus.filter(e => e !== 'PAID');
      }
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFAe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFA = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTAe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTA = event.value || undefined;
    if (this.dpTA) {
      this.dpTA = this.dpTA
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFRe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFA = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTRe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTA = event.value || undefined;
    if (this.dpTR) {
      this.dpTR = this.dpTR
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFPe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFP = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTPe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTP = event.value || undefined;
    if (this.dpTP) {
      this.dpTP = this.dpTP
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFIe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFI = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTIe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTI = event.value || undefined;
    if (this.dpTI) {
      this.dpTI = this.dpTI
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFSDe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTSDe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTSD) {
      this.dpTSD = this.dpTSD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFRDe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTRDe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTRD) {
      this.dpTRD = this.dpTRD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFADe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTADe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTAD) {
      this.dpTAD = this.dpTAD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  //End filter shit
  loadShipmentsList() {
    this.selection.clear();
    const queryParams = new QueryParamsModel(
      this.filterConfiguration(),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize
    );

    if (this.adminView) {
      queryParams.for_staff = true;
    }

    this.store.dispatch(new ShipmentsPageRequested({ page: queryParams }));
    if (this.adminView) {
      this.store.dispatch(new SetFinancialFilters({ filters: queryParams }));
    } else {
      this.store.dispatch(
        new SetUserFinancialFilters({ filters: queryParams })
      );
    }

    this.selection.clear();
  }

  /** FILTRATION */
  filterConfiguration(): any {
    const filter: any = {};

    filter.uids = this.fUsers.map(usr => usr.id);
    filter._ab_uids = this.fabUsers.map(usr => usr.id);
    filter.recipient_name = this.searchInput.nativeElement.value;
    filter.recipient_tel = this.searchInputTel.nativeElement.value;
    filter._status = this.fStatus;
    filter.vg_codes = [...this.fvg_codes];

    if (!this.delivered) {
      filter.is_delivered = false;
    }

    if (this.odelivered) {
      filter.only_delivered = true;
    }

    if (!this.returned) {
      filter.is_returned = false;
    }

    if (this.oreturned) {
      filter.only_returned = true;
    }

    if (this.odsr) {
      filter.odsr = true;
    }

    if (this.arsr) {
      filter.arsr = true;
    }

    if (!this.sprepaid) {
      filter.is_prepaid = false;
    }

    if (this.oprepaid) {
      filter.only_prepaid = true;
    }

    if (this.ord) {
      filter.ord = true;
    }

    if (this.snd_del) {
      filter.snd_del = true;
    }

    if (this.osp) {
      filter.osp = true;
    }

    if (this.nocod) {
      filter.nocod = true;
    }

    if (this.ocod) {
      filter.ocod = true;
    }

    if (this.diffinvw) {
      filter.diffinvw = true;
    }

    if (this.dpFA) {
      filter.dpfa = this.dpFA.format();
    }

    if (this.dpTA) {
      filter.dpta = this.dpTA.format();
    }

    if (this.dpFR) {
      filter.dpfr = this.dpFR.format();
    }

    if (this.dpTR) {
      filter.dptr = this.dpTR.format();
    }

    if (this.dpFP) {
      filter.dpfp = this.dpFP.format();
    }

    if (this.dpTP) {
      filter.dptp = this.dpTP.format();
    }

    if (this.dpFI) {
      filter.dpfi = this.dpFI.format();
    }

    if (this.dpTI) {
      filter.dpti = this.dpTI.format();
    }

    if (this.dpFSD) {
      filter.dpfsd = this.dpFSD.format();
    }

    if (this.dpTSD) {
      filter.dptsd = this.dpTSD.format();
    }

    if (this.dpFRD) {
      filter.dpfrd = this.dpFRD.format();
    }

    if (this.dpTRD) {
      filter.dptrd = this.dpTRD.format();
    }

    if (this.dpFAD) {
      filter.dpfad = this.dpFAD.format();
    }

    if (this.dpTAD) {
      filter.dptad = this.dpTAD.format();
    }

    if (this.courier) {
      filter.courier = this.courier;
    }

    return filter;
  }

  printVoucher(_item: Shipment) {
    this.store.dispatch(new FetchVoucher({ shipment: _item }));
    this.store
      .pipe(
        select(selectShipmentById(_item.id)),
        takeUntil(
          this.actions$.pipe(ofType<GotVoucher>(ShipmentActionTypes.GotVoucher))
        ),
        takeUntil(
          this.actions$.pipe(ofType<ActionFail>(ShipmentActionTypes.ActionFail))
        ),
        last(),
        tap((res: Shipment) => this.actualPrint(res))
      )
      .subscribe();
  }

  printVouchers() {
    const _ids: Array<number> = [];
    this.isPrinting.next(true);

    this.bigBucket.forEach(elem => {
      _ids.push(elem.id);
    });
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    this.http
      .post(
        'api/shipments/mass_print/',
        { ids: _ids },
        { headers: httpHeaders }
      )
      .pipe(
        take(1),
        tap((res: string) => {
          {
            const url = res;
            this.http
              .get(url, {
                headers: new HttpHeaders({
                  'Content-Type': 'application/octet-stream',
                }),
                responseType: 'blob',
              })
              .pipe(
                map(res => {
                  const isFirefox =
                    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                  if (isFirefox) {
                    this.pdfViewerOnDemand.pdfSrc = res;
                    this.pdfViewerOnDemand.refresh();
                  } else {
                    const blob = new Blob([res], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);
                    const iframe = document.createElement('iframe');
                    document.body.appendChild(iframe);
                    iframe.src = blobUrl;
                    iframe.style.display = 'none';
                    return iframe;
                  }
                }),
                delay(4000),
                tap(ifr => {
                  if (ifr) {
                    ifr.contentWindow.print();
                  }
                }),
                finalize(() => this.isPrinting.next(false))
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  actualPrint(item: Shipment) {
    if (!this.isPrinting.value) {
      this.isPrinting.next(true);
      const url = `/api/shipments/${item.id}/pdf_raw/`;
      this.http
        .get(url, {
          headers: new HttpHeaders({
            'Content-Type': 'application/octet-stream',
          }),
          responseType: 'blob',
        })
        .pipe(
          map(res => {
            const isFirefox =
              navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
              this.pdfViewerOnDemand.pdfSrc = res;
              this.pdfViewerOnDemand.refresh();
            } else {
              const blob = new Blob([res], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              const iframe = document.createElement('iframe');
              document.body.appendChild(iframe);
              iframe.src = blobUrl;
              iframe.style.display = 'none';
              return iframe;
            }
          }),
          delay(4000),
          tap(ifr => {
            if (ifr) {
              ifr.contentWindow.print();
            }
          }),
          finalize(() => this.isPrinting.next(false))
        )
        .subscribe();
    }
  }

  check_kg_s(_item: Shipment) {
    this.store.dispatch(new ShipmentCheckWeight({ shipment: _item }));
  }

  check_kg() {
    const _title = 'Διασταύρωση Βάρους';
    const _description = 'Είστε σίγουρος πως θέλετε να ελεγχθούν οι αποστολές;';
    const _waitDesciption = 'Οι αποστολές ελέγχονται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new ShipmentMassCheckWeight({ ids: _ids }));
    });
  }

  markPrepaid(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως Προπληρωμένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPrepaid({ shipment: _item }));
    });
  }

  toggleReturnDelivered(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ToggleReturnDelivered({ shipment: _item }));
    });
  }

  toggleSendDelivered(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ToggleSendDelivered({ shipment: _item }));
    });
  }

  checkReturned(_item: Shipment) {
    this.store.dispatch(new CheckReturned({ shipment: _item }));
    //console.log(_item);
  }

  unmarkPrepaid(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως μη Προπληρωμένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new UnMarkPrepaid({ shipment: _item }));
    });
  }

  markPrereturn(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως Προ-Αποδομένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPrereturn({ shipment: _item }));
    });
  }

  unmarkPrereturn(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως μη Προ-Αποδομένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new UnMarkPrereturn({ shipment: _item }));
    });
  }

  massMarkPrepaid() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προπληρωμένες;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPrepaid({ ids: _ids }));
    });
  }

  massMarkCancellationPending() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προς Ακύρωση;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkCancellationPending({ ids: _ids }));
    });
  }

  shipmentCancel(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description = 'Είστε σίγουρος πως θέλετε να ακυρώσετε την αποστολή;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ShipmentCancel({ shipment: _item }));
    });
  }

  markPaid_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εισπραγμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }

      this.store.dispatch(new MarkPaid({ shipment: _item }));
    });
  }

  markClarification(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Διασάφηση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkClarification({ shipment: _item }));
    });
  }

  markCancellationPending(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Ακύρωση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkCancellationPending({ shipment: _item }));
    });
  }

  markPaidApproved_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Απόδοση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPaidApproved({ shipment: _item }));
    });
  }

  markInvoiced_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εξοφλημένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkInvoiced({ shipment: _item }));
    });
  }

  markProcessed_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εγκεκριμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkProcessed({ shipment: _item }));
    });
  }

  markPaid() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εισπράχτηκε;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPaid({ ids: _ids }));
    });
  }

  markReturned(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Επεστραμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkReturned({ shipment: _item }));
    });
  }

  markPaidApproved() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προς Απόδοση;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPaidApproved({ ids: _ids }));
    });
  }

  markInvoiced() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εξοφλημένη;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkInvoiced({ ids: _ids }));
    });
  }

  markProcessed() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εγκρίθηκε;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkProcessed({ ids: _ids }));
    });
  }

  viewShipment(item: Shipment) {
    this.layoutUtilsService.viewShipment({
      item: item,
      adm: this.adminView,
      financial: true,
    });
  }

  viewShipmentTracking(item: Shipment) {
    this.layoutUtilsService.viewShipment({
      item: item,
      adm: this.adminView,
      financial: false,
    });
  }

  viewVoucher(_item: Shipment) {
    this.store.dispatch(new FetchVoucher({ shipment: _item }));
    this.store
      .pipe(
        select(selectShipmentById(_item.id)),
        takeUntil(
          this.actions$.pipe(ofType<GotVoucher>(ShipmentActionTypes.GotVoucher))
        ),
        takeUntil(
          this.actions$.pipe(ofType<ActionFail>(ShipmentActionTypes.ActionFail))
        ),
        last(),
        tap((res: Shipment) =>
          this.layoutUtilsService.viewVoucher({ item: res })
        )
      )
      .subscribe();
  }

  onFileSelected(event) {
    const inputNode: any = document.querySelector('#file');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            cod_ammount: parseFloat('' + Object.values(k)[1]),
          })
        );
        //var nng:number = refined.filter( (k:any) => !(''+k.vg_code).startsWith("NG") ).length;
        //if(nng) {
        //    this.customWarning.next(`Βρέθηκαν ${nng} αποστολές με μη συμβατό κωδικό αποστολής ( κωδ. αποστολής που δεν ξεκινάει απο 'NG' ).`);
        //}
        //refined = refined.filter( (k:any) => (''+k.vg_code).startsWith("NG") );
        this.store.dispatch(new MarkAsPaidByXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onFileSelectedElta2(event) {
    const inputNode: any = document.querySelector('#file_elta2');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            cod_ammount: parseFloat('' + Object.values(k)[1]),
          })
        );
        //var nng:number = refined.filter( (k:any) => !(''+k.vg_code).startsWith("NG") ).length;
        //if(nng) {
        //    this.customWarning.next(`Βρέθηκαν ${nng} αποστολές με μη συμβατό κωδικό αποστολής ( κωδ. αποστολής που δεν ξεκινάει απο 'NG' ).`);
        //}
        //refined = refined.filter( (k:any) => (''+k.vg_code).startsWith("NG") );
        this.store.dispatch(new MarkAsPaidByXLS_ELTA2({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onXLSSearchSelected(event) {
    const inputNode: any = document.querySelector('#file_search');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol) {
            if (e[vgCol]) {
              refined.push({ vg_code: '' + e[vgCol].replace(/\s/g, '') });
            }
          }

          const vals = Object.values(e);
          for (const [key, value] of Object.entries(e)) {
            if (('' + value).includes('ΣΥΔΕΤΑ')) {
              vgCol = key;
            }
          }
        });
        console.log(refined);
        const codes: Array<string> = [];
        refined.forEach(sh => codes.push(sh.vg_code));

        this.fvg_codes = [...codes];
        this.refs();
        //this.store.dispatch(new ValidateSPDX({items: refined}));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onCSPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_cs');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;
        let manifestCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol && manifestCol) {
            if (e[vgCol] && e[codCol] && e[manifestCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αποδεικτικό Αποστολής') &&
            vals.includes('Ποσό') &&
            vals.includes('Αρ.Μανιφέστου')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό') {
                codCol = key;
              }
              if (value === 'Αρ.Μανιφέστου') {
                manifestCol = key;
              }
            }
          }
        });
        this.store.dispatch(new MarkAsPaidByXLS_CS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSPDXPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_spdx');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αριθμός Αποστολής') &&
            vals.includes('Ποσό Αντικαταβολής')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό Αντικαταβολής') {
                codCol = key;
              }
            }
          }
        });
        this.store.dispatch(new MarkAsPaidByXLS_SPDX({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onTaxyPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_taxy');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αποδεικτικό Αποστολής') &&
            vals.includes('Ποσό Αντικαταβολής')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό Αντικαταβολής') {
                codCol = key;
              }
            }
          }
        });

        this.store.dispatch(new MarkAsPaidByXLS_TAXY({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onACSPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_acs');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αποδεικτικό') && vals.includes('Ποσό')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό') {
                vgCol = key;
              }
              if (value === 'Ποσό') {
                codCol = key;
              }
            }
          }
        });

        this.store.dispatch(new MarkAsPaidByXLS_ACS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onACSCheckSelected($event) {
    const inputNode: any = document.querySelector('#file_acs_check');
    const file: File = $event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        console.log(res);
        let vgCol: any;
        let w1Col: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && w1Col) {
            if (e[vgCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                w1: parseFloat('' + parseFloat('' + e[w1Col]).toFixed(2)),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός Αποδεικτικού') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποδεικτικού') {
                vgCol = key;
              }
              if (value === 'Βάρος') {
                w1Col = key;
              }
            }
          }
        });

        this.store.dispatch(new CheckKgByXLS_ACS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onKronosPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_kronos');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αρ. Δελτίου') && vals.includes('Μετρητά')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αρ. Δελτίου') {
                vgCol = key;
              }
              if (value === 'Μετρητά') {
                codCol = key;
              }
            }
          }
        });
        //console.log(refined);
        this.store.dispatch(new MarkAsPaidByXLS_KRONOS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onKronosApprovedSelected(event) {
    const inputNode: any = document.querySelector('#file_kronos_app');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let idCol: any;

        let refined: Array<any> = [];
        const regExp = /\(([^)]+)\)/;

        res.forEach(e => {
          if (vgCol && idCol) {
            if (e[vgCol] && e[idCol]) {
              const parsed = regExp.exec(e[idCol]);
              if (parsed && parsed.length > 1) {
                refined.push({
                  vg_code: '' + e[vgCol].replace(' ', ''),
                  id: parsed[1],
                });
              }
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('ΑΡΙΘΜΟΣ ΑΠΟΣΤΟΛΗΣ') &&
            vals.includes('ΠΑΡΑΤΗΡΗΣΕΙΣ')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'ΑΡΙΘΜΟΣ ΑΠΟΣΤΟΛΗΣ') {
                vgCol = key;
              }
              if (value === 'ΠΑΡΑΤΗΡΗΣΕΙΣ') {
                idCol = key;
              }
            }
          }
        });
        // remove whatever doesn't start with 4 from refined
        refined = refined.filter((k: any) => ('' + k.vg_code).startsWith('4'));
        //console.log(refined);
        this.store.dispatch(new MarkAsApprovedByXLS_KRONOS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onCkeckKgSelected(event) {
    const inputNode: any = document.querySelector('#file_check_kg');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;
        let w1Col: any;
        let w2Col: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && w1Col && w2Col) {
            if (e[vgCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                w1: parseFloat('' + parseFloat('' + e[w1Col]).toFixed(2)),
                w2: parseFloat('' + parseFloat('' + e[w2Col]).toFixed(2)),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός φορτωτικής') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός φορτωτικής') {
                vgCol = key;
              }
              if (value === 'Βάρος' && !w1Col) {
                w1Col = key;
              }
              if (value === 'Βάρος' && w1Col) {
                w2Col = key;
              }
            }
          }
        });
        this.store.dispatch(new CheckKgByXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSPDXValidateSelected(event) {
    const inputNode: any = document.querySelector('#file_spdx_validate');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;
        let wCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && wCol) {
            if (e[vgCol] && e[wCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                weight: parseFloat('' + e[wCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός Αποστολής') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποστολής') {
                vgCol = key;
              }
              if (value === 'Βάρος') {
                wCol = key;
              }
            }
          }
        });
        this.store.dispatch(new ValidateSPDX({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSendDeliveredSelected(event) {
    const inputNode: any = document.querySelector('#file_send_delivered');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            weight: Object.values(k)[1]
              ? parseFloat('' + Object.values(k)[1])
              : undefined,
          })
        );
        //console.log(refined);
        this.store.dispatch(new SendDeliveredXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onReturnDeliveredSelected(event) {
    const inputNode: any = document.querySelector('#file_return_delivered');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        const refined: Array<any> = [];
        res.forEach(k => {
          if (Object.values(k)[1] && Object.values(k)[2]) {
            refined.push({
              vg_code: '' + Object.values(k)[0],
              kap: '' + Object.values(k)[1],
              weight: parseFloat(
                '' + parseFloat('' + Object.values(k)[2]).toFixed(2)
              ),
            });
          } else {
            refined.push({ vg_code: '' + Object.values(k)[0] });
          }
        });
        //console.log(refined);
        this.store.dispatch(new ReturnDeliveredXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  createCodXLS(return_f = false): any {
    return import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;
      const ids: Array<number> = [];
      this.bigBucket
        .filter(row => row._status === 'PAID_APPROVED')
        .filter(row => row.is_cod)
        .filter(row => parseFloat('' + row.cod_ammount) != 0)
        .forEach(elem => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Ποσό Αντικαταβολής'] = parseFloat(
            '' + (elem.cod_ammount || 0)
          ).toFixed(2);
          if (elem.is_prereturn) {
            o['Αποδοτέο'] = parseFloat(
              '' +
                ((parseFloat('' + elem.cod_ammount) || 0) -
                  (parseFloat('' + elem.prereturn_ammount) || 0))
            ).toFixed(2);
            sum += parseFloat(
              parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
            );
            sum -= parseFloat(
              parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
            );
          } else {
            o['Αποδοτέο'] = parseFloat(
              '' + (parseFloat('' + elem.cod_ammount) || 0)
            ).toFixed(2);
            sum += parseFloat(
              parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
            );
          }
          o['Ημερομηνία Έγκρισης'] = elem.date_approved
            ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
            : '';
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          data.push(o);
        });
      this.bigBucket
        .filter(row => row._status === 'RETURNED' && row.is_prereturn)
        .filter(row => row.is_cod)
        .filter(row => parseFloat('' + row.cod_ammount) != 0)
        .forEach(elem => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Ποσό Αντικαταβολής'] = parseFloat(
            '' + (elem.cod_ammount || 0)
          ).toFixed(2);
          o['Αποδοτέο'] = parseFloat(
            '' + (-1 * parseFloat('' + elem.prereturn_ammount) || 0)
          ).toFixed(2);
          sum -= parseFloat(
            parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
          );
          o['Ημερομηνία Έγκρισης'] = elem.date_approved
            ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
            : '';
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          data.push(o);
        });
      if (this.bigBucket.length > 0) {
        this.store
          .pipe(
            select(selectUserById(this.bigBucket[0].user)),
            take(1),
            tap(res => {
              if (res.allow_prereturns) {
                this.bigBucket
                  .filter(row => row._status === 'PROCESSED')
                  .filter(row => row.is_cod)
                  .filter(row => parseFloat('' + row.cod_ammount) != 0)
                  .filter(row => !row.is_prereturn)
                  .filter(row => row.is_delivered)
                  .forEach(elem => {
                    ids.push(elem.id);
                    const o: { [k: string]: any } = {};
                    o['Όνομα Παραλήπτη'] = elem.recipient_name;
                    o['Κωδικός Αποστολής'] = elem.vg_code;
                    o['Ποσό Αντικαταβολής'] = parseFloat(
                      '' + (elem.cod_ammount || 0)
                    ).toFixed(2);
                    let tmp_ammount =
                      (parseFloat(
                        parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
                      ) *
                        parseFloat('' + res.prereturn_perc)) /
                      100;
                    tmp_ammount = parseFloat(tmp_ammount.toFixed(2));
                    o['Αποδοτέο'] = parseFloat(
                      '' +
                        (tmp_ammount > parseFloat('' + res.prereturn_max)
                          ? parseFloat('' + res.prereturn_max)
                          : tmp_ammount)
                    ).toFixed(2);
                    sum +=
                      tmp_ammount > parseFloat('' + res.prereturn_max)
                        ? parseFloat('' + res.prereturn_max)
                        : tmp_ammount;
                    o['Ημερομηνία Έγκρισης'] = elem.date_approved
                      ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
                      : '';
                    o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
                    data.push(o);
                  });
              }
            })
          )
          .subscribe();
      }
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Κωδικός Αποστολής': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αποδοτέο': undefined,
        'Ημερομηνία Έγκρισης': undefined,
      });
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Κωδικός Αποστολής': 'Σύνολο',
        'Ποσό Αντικαταβολής': undefined,
        'Αποδοτέο': parseFloat('' + sum).toFixed(2),
        'Ημερομηνία Έγκρισης': undefined,
      });
        /* eslint-enable */
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 40 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      if (return_f) {
        const wbout = XLSX.write(workBook, {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
        });
        const bdata = new Blob([this.s2ab(wbout)], {
          type: 'application/octet-stream',
        });
        return {
          file: new File([bdata], 'cod_xls.xlsx', {
            type: 'application/octet-stream',
            lastModified: Date.now(),
          }),
          ids: ids,
        };
      } else {
        const user = this.fUsers[0];
        XLSX.writeFile(
          workBook,
          `${user.id}_${user.kap} ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ ${this.dp.transform(
            Date.now(),
            'dd-MM-yyyy'
          )}.xlsx`
        );
      }
    });
  }

  private prereturnCharge(item: Shipment, user: User): number {
    const amount = parseFloat(
      parseFloat('' + user.prereturn_charge).toFixed(2)
    );
    return (
      amount +
      calculatePercentageCharges(amount, item.area_charges).reduce(
        (sum, charge) => sum + charge.tc,
        0
      )
    );
  }

  createChargesXLS(return_f = false): any {
    return import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;
      const ids: Array<number> = [];

      //Take care of all shipments that need only prereturn charge first
      const tuid: number = this.fUsers[0].id;
      this.store
        .pipe(
          select(selectUserById(tuid)),
          take(1),
          tap(tusr => {
            if (tusr.allow_prereturns) {
              this.bigBucket
                .filter(row => row._status === 'PROCESSED')
                .filter((row: any) => {
                  return (
                    row.is_prepaid === true &&
                    row.is_delivered === true &&
                    row.is_prereturn === false &&
                    row.is_cod &&
                    parseFloat('' + row.cod_ammount) > 0
                  );
                })
                .forEach((elem: any) => {
                  ids.push(elem.id);
                  const o: { [k: string]: any } = {};
                  o['Όνομα Παραλήπτη'] = elem.recipient_name;
                  o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
                  o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
                  o['TK Παραλήπτη'] = elem.recipient_postcode;
                  o['Αποστολέας'] =
                    tusr.id + ' ' + tusr.lastname + ' ' + tusr.firstname;
                  o['Όνομα Παραλήπτη'] = `${tusr.id} ${o['Όνομα Παραλήπτη']}`;
                  o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
                  o['Κωδικός Αποστολής'] = elem.vg_code;
                  o['Κωδικός Επιστροφής'] = elem.vg_code_return;
                  o['Βάρος'] = elem.weight;
                  o['Τεμάχια'] = elem.items;
                  o['Πάγιο'] = undefined;
                  o['Αντικαταβολή'] = undefined;
                  o['Υπέρβαρο'] = undefined;
                  const fee = this.prereturnCharge(elem, tusr);
                  o['Επιπλέον Χρεώσεις'] = fee;
                  o['Αξία'] = fee;
                  o['Σύνολο'] = fee * (1 + tusr.vat_val / 100);
                  sum += fee * (1 + tusr.vat_val / 100);
                  data.push(o);
                });
            }
          })
        )
        .subscribe();

      //Now take care of the rest
      this.bigBucket
        .filter(
          row =>
            row._status === 'PAID_APPROVED' ||
            row._status === 'PROCESSED' ||
            row._status === 'RETURNED'
        )
        .filter((row: any) => {
          return (
            row.is_prepaid === false ||
            (row.is_prepaid &&
              parseFloat(row.cost).toFixed(2) !==
                parseFloat(row.prepaid_ammount).toFixed(2) &&
              row.prepaid_ammount &&
              row._status !== 'PROCESSED')
          );
        })
        .forEach((elem: any) => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
          o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
          o['TK Παραλήπτη'] = elem.recipient_postcode;
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Αποστολέας'] =
                  res.id + ' ' + res.lastname + ' ' + res.firstname;
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          //o['Αποστολέας'] = elem.user;
          o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Κωδικός Επιστροφής'] = elem.vg_code_return;
          o['Βάρος'] = elem.weight;
          o['Τεμάχια'] = elem.items;
          o['Πάγιο'] = parseFloat(parseFloat(elem.basec).toFixed(2));
          o['Αντικαταβολή'] = parseFloat(parseFloat(elem.codc).toFixed(2));
          o['Υπέρβαρο'] = parseFloat(parseFloat(elem.ekgc).toFixed(2));
          if (
            elem.is_prepaid &&
            parseFloat(elem.cost).toFixed(2) !==
              parseFloat(elem.prepaid_ammount).toFixed(2) &&
            elem.prepaid_ammount
          ) {
            let pawo_vat = parseFloat(
              parseFloat(elem.prepaid_ammount).toFixed(2)
            );
            if (parseFloat(elem.vat) > 0) {
              pawo_vat =
                parseFloat(parseFloat(elem.prepaid_ammount).toFixed(2)) /
                (1 + parseFloat(elem.vat) / 100);
              pawo_vat = parseFloat(pawo_vat.toFixed(2));
            }
            o['Επιπλέον Χρεώσεις'] =
              parseFloat(parseFloat(elem.ec).toFixed(2)) - pawo_vat;
            o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2)) - pawo_vat;
            o['Σύνολο'] =
              parseFloat(parseFloat(elem.cost).toFixed(2)) -
              parseFloat(parseFloat(elem.prepaid_ammount || 0).toFixed(2));
            sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
            sum -= parseFloat(parseFloat(elem.prepaid_ammount || 0).toFixed(2));
          } else {
            o['Επιπλέον Χρεώσεις'] = parseFloat(parseFloat(elem.ec).toFixed(2));
            o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2));
            o['Σύνολο'] = parseFloat(parseFloat(elem.cost).toFixed(2));
            sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));

            this.store
              .pipe(
                select(selectUserById(elem.user)),
                take(1),
                tap(res => {
                  if (
                    res.allow_prereturns &&
                    elem._status === 'PROCESSED' &&
                    elem.is_cod &&
                    parseFloat('' + elem.cod_ammount) > 0 &&
                    elem.is_delivered &&
                    !elem.is_prereturn
                  ) {
                    const fee = this.prereturnCharge(elem, res);
                    o['Επιπλέον Χρεώσεις'] += fee;
                    o['Αξία'] += fee;
                    o['Σύνολο'] += fee * (1 + res.vat_val / 100);
                    sum += fee * (1 + res.vat_val / 100);
                  }
                })
              )
              .subscribe();
          }
          data.push(o);
        });
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });
      /* eslint-enable */
      this.extraCharges.forEach((elem: any) => {
        const o: { [k: string]: any } = {};
        o['Όνομα Παραλήπτη'] = 'Επιπλέον Χρέωση/Επιστροφή';
        o['Διεύθυνση Παραλήπτη'] = 'Αιτιολογία:';
        o['Τηλέφωνο Παραλήπτη'] = elem.reason;
        o['TK Παραλήπτη'] = undefined;
        o['Αποστολέας'] = undefined;
        o['Ποσό Αντικαταβολής'] = undefined;
        o['Κωδικός Αποστολής'] = undefined;
        o['Κωδικός Επιστροφής'] = undefined;
        o['Βάρος'] = undefined;
        o['Τεμάχια'] = undefined;
        o['Πάγιο'] = undefined;
        o['Αντικαταβολή'] = undefined;
        o['Υπέρβαρο'] = undefined;
        o['Επιπλέον Χρεώσεις'] = undefined;
        o['Αξία'] = undefined;
        o['Σύνολο'] = parseFloat(parseFloat(elem.charge).toFixed(2));
        sum += parseFloat(parseFloat(elem.charge || 0).toFixed(2));
        data.push(o);
      });
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });

      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': 'Σύνολο',
        'Σύνολο': sum,
      });
        /* eslint-enable */
      data.forEach(row => {
        const total = row['Σύνολο'];
        if (typeof total === 'number') {
          row['Σύνολο'] = parseFloat(total.toFixed(2));
        }
      });
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      if (return_f) {
        const wbout = XLSX.write(workBook, {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
        });
        const bdata = new Blob([this.s2ab(wbout)], {
          type: 'application/octet-stream',
        });
        return {
          file: new File([bdata], 'charges_xls.xlsx', {
            type: 'application/octet-stream',
            lastModified: Date.now(),
          }),
          ids: ids,
        };
      } else {
        const user = this.fUsers[0];
        XLSX.writeFile(
          workBook,
          `${user.id}_${user.kap} ΑΝΑΛΥΣΗ ΧΡΕΩΣΕΩΝ ${this.dp.transform(
            Date.now(),
            'dd-MM-yyyy'
          )}.xlsx`
        );
      }
    });
  }

  genXLS() {
    import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;

      this.bigBucket.forEach((elem: any) => {
        const o: { [k: string]: any } = {};
        o['ID Πελάτη'] = undefined;
        o['Όνομα Παραλήπτη'] = elem.recipient_name;
        o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
        o['Περιοχή Παραλήπτη'] = elem.recipient_selected_area
          ? elem.recipient_selected_area.name +
            ' ' +
            elem.recipient_selected_area.nomos
          : elem.recipient_area;
        o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
        o['TK Παραλήπτη'] = elem.recipient_postcode;
        o['Παρατηρήσεις'] = elem.user_comments
          ? `(${elem.id}) ${elem.user_comments}`
          : `(${elem.id})`;
        o['Ημερομηνία Έγκρισης'] = elem.date_approved
          ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
          : '';
        o['Ημερομηνία Παράδοσης'] = elem.date_delivered
          ? this.dp.transform(elem.date_delivered, 'dd/MM/yyyy')
          : '';
        this.store
          .pipe(
            select(selectUserById(elem.user)),
            take(1),
            tap(res => {
              o['Αποστολέας'] =
                res.id + ' ' + res.lastname + ' ' + res.firstname;
              o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              o['ID Πελάτη'] = res.id;
            })
          )
          .subscribe();
        //o['Αποστολέας'] = elem.user;
        o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
        o['Αμ.Απ.'] = elem.prereturn_ammount || 0;
        o['Κωδικός Αποστολής'] = elem.vg_code;
        o['Κωδικός Επιστροφής'] = elem.vg_code_return;
        o['Τιμολ. Βάρος'] = elem.spdx_validated_weight;
        o['Βάρος'] = elem.weight;
        o['Τεμάχια'] = elem.items;
        o['Πάγιο'] = parseFloat(parseFloat(elem.basec).toFixed(2));
        o['Αντικαταβολή'] = parseFloat(parseFloat(elem.codc).toFixed(2));
        o['Υπέρβαρο'] = parseFloat(parseFloat(elem.ekgc).toFixed(2));
        o['Επιπλέον Χρεώσεις'] = parseFloat(parseFloat(elem.ec).toFixed(2));
        o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2));
        o['Σύνολο'] = parseFloat(parseFloat(elem.cost).toFixed(2));
        sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
        data.push(o);
      });
      /* eslint-disable */
      data.push({
        'ID Πελάτη': undefined,
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Περιοχή Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Παρατηρήσεις': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αμ.Απ.': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Τιμολ. Βάρος': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });
      data.push({
        'ID Πελάτη': undefined,
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Περιοχή Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Παρατηρήσεις': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αμ.Απ.': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Τιμολ. Βάρος': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': 'Σύνολο',
        'Σύνολο': sum,
      });
      /* eslint-enable */
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 12 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      XLSX.writeFile(
        workBook,
        this.makeid(10) + '-' + this.makeid(4) + '.xlsx'
      );
    });
  }

  makeid(length) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAlertClose($event) {
    this.serverError.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onWarningClose($event) {
    this.customWarning.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose($event) {
    this.customInfo.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose2($event) {
    this.customInfo2.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose3($event) {
    this.customInfo3.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose4($event) {
    this.customInfo4.next(false);
  }

  createReceipt(return_f = false): any {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      let AAA: GConfig;

      this.store
        .pipe(
          select(selectGConfigById('general__AAA')),
          take(1),
          tap(res => (AAA = { ...res }))
        )
        .subscribe();

      AAA.value = '' + (parseInt(AAA.value) + 1);

      this.store.dispatch(new GConfigUpdate({ gconfig: AAA }));

      this.store
        .pipe(
          select(selectGConfigById('general__AAA')),
          takeWhile(
            (res: GConfig) => res.value !== '' + (parseInt(AAA.value) - 1),
            true
          ),
          takeUntil(
            this.actions$.pipe(
              ofType<GCActionFail>(GConfigActionTypes.GCActionFail)
            )
          ),
          takeUntil(
            this.actions$.pipe(
              ofType<GCActionSuccess>(GConfigActionTypes.GCActionSuccess)
            )
          )
        )
        .subscribe(res => {
          //Some level of error control on Action fail is required

          const user: User = this.fUsers[0];
          let ptext = '';
          if (!user.is_company) {
            ptext += `Πληρώσαμε τον/την ${user.lastname} ${user.firstname}, ιδιώτη, με `;
            if (user.adt !== '' && user.adt) {
              ptext += `ΑΔΤ ${user.adt} `;
            } else {
              ptext += `ΑΦΜ ${user.vat} `;
            }
            ptext += `και κωδικό αριθμό πελάτη ${user.kap}, διεύθυνση ${user.user_address} `;
            if (user.city && user.city !== '') {
              ptext += `${user.city} `;
            }
            ptext += `, τηλέφωνο ${
              user.mobile ? user.mobile : user.phone
            }, τις αντικαταβολές που εισπράξαμε για λογαριασμό του/της, σύμφωνα με το μεταξύ μας ιδιωτικό συμφωνητικό συνεργασίας - σύμβαση παροχής υπηρεσιών.`;
          } else {
            ptext += `Πληρώσαμε την εταιρία ${user.companyName} , με ΑΦΜ ${user.companyVat} `;
            ptext += `και κωδικό αριθμό πελάτη ${user.kap}, διεύθυνση ${user.companyAddress} `;
            if (user.companyCity && user.companyCity !== '') {
              ptext += `${user.companyCity} `;
            }
            ptext += `, τηλέφωνο ${
              user.mobile ? user.mobile : user.phone
            }, τις αντικαταβολές που εισπράξαμε για λογαριασμό της, σύμφωνα με το μεταξύ μας ιδιωτικό συμφωνητικό συνεργασίας - σύμβαση παροχής υπηρεσιών.`;
          }

          let apod = 0;
          let charges = 0;
          let echarges = 0;
          const ids: Array<number> = [];
          this.bigBucket
            .filter(
              row =>
                row._status === 'PAID_APPROVED' ||
                row._status === 'PROCESSED' ||
                row._status === 'RETURNED'
            )
            .forEach((elem: any) => {
              ids.push(elem.id);
              if (elem._status === 'PAID_APPROVED') {
                apod += parseFloat(
                  parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
                );
                if (elem.is_prereturn) {
                  apod -= parseFloat(
                    parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
                  );
                }
              }

              if (elem._status === 'RETURNED' && elem.is_prereturn) {
                apod -= parseFloat(
                  parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
                );
              }

              if (
                elem._status === 'PROCESSED' &&
                elem.is_cod &&
                parseFloat('' + elem.cod_ammount) > 0
              ) {
                this.store
                  .pipe(
                    select(selectUserById(this.bigBucket[0].user)),
                    take(1),
                    tap(res => {
                      if (res.allow_prereturns) {
                        if (elem.is_delivered && !elem.is_prereturn) {
                          const tmp_ammount =
                            (parseFloat(
                              parseFloat('' + (elem.cod_ammount || 0)).toFixed(
                                2
                              )
                            ) *
                              parseFloat('' + res.prereturn_perc)) /
                            100;
                          apod +=
                            tmp_ammount > parseFloat('' + res.prereturn_max)
                              ? parseFloat('' + res.prereturn_max)
                              : tmp_ammount;
                          charges +=
                            this.prereturnCharge(elem, res) *
                            (1 + parseFloat('' + res.vat_val) / 100);
                        }
                      }
                    })
                  )
                  .subscribe();
              }
              if (elem.is_prepaid === false) {
                charges += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
              }

              if (
                elem.is_prepaid &&
                parseFloat(elem.cost).toFixed(2) !==
                  parseFloat(elem.prepaid_ammount).toFixed(2) &&
                elem.prepaid_ammount &&
                elem._status !== 'PROCESSED'
              ) {
                charges += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
                charges -= parseFloat(
                  parseFloat(elem.prepaid_ammount || 0).toFixed(2)
                );
              }
            });

          this.extraCharges.forEach((elem: any) => {
            echarges += parseFloat(parseFloat(elem.charge || 0).toFixed(2));
          });

          const documentDefinition = {
            pageSize: 'A4',
            content: [
              {
                columns: [
                  [
                    {
                      image:
                        'data:image/png;base64,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',
                      width: 130,
                      alignment: 'center',
                    },
                    {
                      text: 'Email: rex.gr@gmail.com',
                      style: 'header_tiny',
                    },
                  ],
                  [
                    {
                      text: `ΑΠΟΔΕΙΞΗ ΠΛΗΡΩΜΗΣ Νο: ${user.kap}-${res.value}`,
                      alignment: 'center',
                      fontSize: 14,
                      bold: true,
                      margin: [0, 2, 0, 4],
                      color: '#444',
                    },
                    {
                      text: formatCurrency(apod, 'el-GR', '€'),
                      alignment: 'center',
                      fontSize: 18,
                      bold: true,
                      margin: [0, 0, 0, 4],
                      color: '#222',
                    },
                    {
                      text: 'ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ',
                      alignment: 'center',
                      fontSize: 12,
                      bold: true,
                      color: '#444',
                    },
                    {
                      text: formatDate(Date.now(), 'dd/MM/yyyy', 'el-GR'),
                      alignment: 'center',
                      fontSize: 7,
                      bold: true,
                      color: '#444',
                    },
                  ],
                ],
              },
              {
                text: ptext,
                margin: [0, 40, 0, 4],
                color: '#222',
                lineHeight: 1.3,
                fontSize: 10,
                alignment: 'justify',
              },
              {
                margin: [0, 12, 0, 4],
                stack: [
                  {
                    text: 'ΔΗΛΩΣΗ ΠΑΡΑΛΑΒΗΣ ΑΝΤΙΚΑΤΑΒΟΛΩΝ Ιδιώτη ή Επαγγελματία – Διαχείριση Εισπράξεων',
                    fontSize: 8,
                    bold: true,
                    color: '#222',
                    alignment: 'center',
                    margin: [0, 0, 0, 4],
                  },
                  {
                    text: 'Δηλώνω ότι παρέλαβα από την εταιρεία REX COURIER ΙΚΕ το ανωτέρω ποσό, το οποίο αφορά αντικαταβολές αποστολών που πραγματοποιήθηκαν μέσω του δικτύου συνεργαζόμενων εταιρειών ταχυμεταφοράς.',
                    fontSize: 7,
                    color: '#222',
                    alignment: 'justify',
                    margin: [0, 0, 0, 3],
                  },
                  {
                    text: 'Αναγνωρίζω ότι:',
                    fontSize: 7,
                    bold: true,
                    color: '#222',
                    margin: [0, 0, 0, 1],
                  },
                  {
                    ul: [
                      'η εταιρεία REX COURIER ΙΚΕ ενεργεί αποκλειστικά ως πάροχος υπηρεσιών μεταφοράς και διαχείρισης είσπραξης αντικαταβολών',
                      'τα ποσά αντικαταβολών προέρχονται από συναλλαγές αποστολής αντικειμένων μου προς τρίτους παραλήπτες',
                      'η εταιρεία REX COURIER ΙΚΕ δεν αποτελεί συμβαλλόμενο μέρος στις συναλλαγές αυτές',
                    ],
                    fontSize: 7,
                    color: '#222',
                    margin: [8, 0, 0, 3],
                  },
                  {
                    text: 'Ιδιώτης, Δηλώνω ότι:',
                    fontSize: 7,
                    bold: true,
                    color: '#222',
                    margin: [0, 0, 0, 1],
                  },
                  {
                    ul: [
                      'οι συναλλαγές μου δεν έχουν συστηματικό ή επαγγελματικό χαρακτήρα',
                      'φέρω την ευθύνη για τη νομιμότητα και τη φύση των συναλλαγών',
                      'φέρω την ευθύνη συμμόρφωσης με τη φορολογική νομοθεσία, εφόσον προκύπτει σχετική υποχρέωση',
                    ],
                    fontSize: 7,
                    color: '#222',
                    margin: [8, 0, 0, 3],
                  },
                  {
                    text: 'Επαγγελματίας, Δηλώνω ότι:',
                    fontSize: 7,
                    bold: true,
                    color: '#222',
                    margin: [0, 0, 0, 1],
                  },
                  {
                    ul: [
                      'τα ποσά αντικαταβολών προέρχονται από πωλήσεις προϊόντων ή υπηρεσιών στο πλαίσιο της επαγγελματικής μου δραστηριότητας',
                      'φέρω την αποκλειστική ευθύνη για τη δήλωση των εσόδων μου',
                      'φέρω την ευθύνη για την έκδοση των νόμιμων φορολογικών παραστατικών προς τους πελάτες μου',
                      'τηρώ τις υποχρεώσεις που απορρέουν από την ισχύουσα φορολογική και εμπορική νομοθεσία',
                    ],
                    fontSize: 7,
                    color: '#222',
                    margin: [8, 0, 0, 3],
                  },
                  {
                    text: 'Δηλώνω ότι:',
                    fontSize: 7,
                    bold: true,
                    color: '#222',
                    margin: [0, 0, 0, 1],
                  },
                  {
                    ul: [
                      'η εταιρεία REX COURIER ΙΚΕ δεν φέρει καμία ευθύνη για φορολογικές, λογιστικές ή άλλες υποχρεώσεις που απορρέουν από τις συναλλαγές μου',
                      'η εταιρεία REX COURIER ΙΚΕ περιορίζεται αποκλειστικά στη μεταφορά και απόδοση των εισπραχθέντων ποσών.',
                    ],
                    fontSize: 7,
                    color: '#222',
                    margin: [8, 0, 0, 0],
                  },
                ],
              },
              {
                columns: [
                  {},
                  [
                    {
                      text: 'Ο Εισπράξας',
                      alignment: 'center',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 7, 0, 4],
                      color: '#222',
                      decoration: 'underline',
                    },
                    {
                      text: '( Υπογραφή, Ονοματεπώνυμο και Αριθμό Δελτίου Ταυτότητας )',
                      alignment: 'center',
                      fontSize: 7,
                      bold: true,
                      margin: [0, 2, 0, 4],
                      color: '#666',
                    },
                    {
                      text: 'Ημερομηνία:    ____ / ____ / _______',
                      alignment: 'center',
                      fontSize: 9,
                      bold: true,
                      margin: [0, 50, 0, 4],
                      color: '#444',
                    },
                  ],
                ],
              },
              {
                margin: [0, 32, 0, 4],
                layout: {
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  fillColor: function (rowIndex, node, columnIndex) {
                    if (rowIndex === 0) {
                      return '#0b95bf';
                    }
                    if (rowIndex === 4) {
                      return '#9cd7ee';
                    }
                    return rowIndex % 2 === 0 ? '#e1f8ff' : '#fff';
                  },
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  hLineWidth: function (i, node) {
                    return 0.1;
                  },
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  vLineWidth: function (i, node) {
                    return 0.1;
                  },
                },
                table: {
                  headerRows: 1,
                  widths: ['*', 'auto'],
                  body: [
                    [
                      {
                        text: 'ΕΚΚΑΘΑΡΙΣΗ ΛΟΓΑΡΙΑΣΜΟΥ',
                        alignment: 'left',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 0, 4],
                        color: '#fff',
                      },
                      {
                        text: 'ΠΟΣΟ',
                        alignment: 'right',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#fff',
                      },
                    ],
                    [
                      {
                        text: 'Απόδοση Αντικαταβολών',
                        alignment: 'left',
                        fontSize: 8,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(apod, 'el-GR', '€'),
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: 'Αποστολές με ReX - Συμψηφισμός',
                        alignment: 'left',
                        fontSize: 8,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(-1 * charges, 'el-GR', '€'),
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: '',
                        alignment: 'right',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: '    ',
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: 'ΣΥΝΟΛΟ',
                        alignment: 'right',
                        fontSize: 10,
                        bold: true,
                        margin: [5, 4, 9, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(
                          apod - charges - echarges,
                          'el-GR',
                          '€'
                        ),
                        alignment: 'right',
                        fontSize: 10,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                  ],
                },
              },
            ],
            styles: {
              header: {
                fontSize: 22,
                bold: true,
                color: '#444',
                alignment: 'center',
              },
              header_small: {
                fontSize: 10,
                alignment: 'center',
                color: '#222',
              },
              header_tiny: {
                fontSize: 7,
                alignment: 'center',
                color: '#444',
              },
            },
          };

          this.extraCharges.forEach((elem: any) => {
            const kk = [
              {
                text: elem.reason,
                alignment: 'left',
                fontSize: 8,
                margin: [5, 4, 0, 4],
                color: '#222',
              },
              {
                text: formatCurrency(
                  -1 * parseFloat(elem.charge),
                  'el-GR',
                  '€'
                ),
                alignment: 'right',
                fontSize: 8,
                bold: true,
                margin: [5, 4, 5, 4],
                color: '#222',
              },
            ];
            documentDefinition.content[4].table.body.splice(3, 0, kk);
          });
          const pp = this.extraCharges.length || 0;
          documentDefinition.content[4].layout.fillColor = function (
            rowIndex,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            node,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            columnIndex
          ) {
            if (rowIndex === 0) {
              return '#0b95bf';
            }
            if (rowIndex === 4 + pp) {
              return '#9cd7ee';
            }
            return rowIndex % 2 === 0 ? '#e1f8ff' : '#fff';
          };

          //console.log(documentDefinition);
          //pdfMake.vfs = pdfFonts.pdfMake.vfs;
          if (return_f) {
            pdfMake.createPdf(documentDefinition).getBlob(blob => {
              resolve({
                file: new File([blob], 'receipt.pdf', {
                  type: 'application/pdf',
                  lastModified: Date.now(),
                }),
                ids: ids,
                cod_sum: apod,
                charge_sum: charges + echarges,
                aaa: res.value,
              });
            });
          } else {
            pdfMake
              .createPdf(documentDefinition)
              .download(
                `${user.id}_${user.kap} ΑΠΟΔΕΙΞΗ ΕΙΣΠΡΑΞΗΣ ${this.dp.transform(
                  Date.now(),
                  'dd-MM-yyyy'
                )}.pdf`
              );
          }
        });
    });
  }

  //Handle bigBucket Selection
  toggleSelection(row: any) {
    this.selection.toggle(row);

    if (this.selection.isSelected(row)) {
      //Push object copy to the bucket
      this.bigBucket.push({ ...row });
    } else {
      //Remove object from the bucket
      this.bigBucket = this.bigBucket.filter(item => item.id !== row.id);
    }
  }

  clearSelection() {
    this.bigBucket.splice(0, this.bigBucket.length);
    this.selection.clear();
  }

  masterToggle() {
    if (this.selection.selected.length === this.shipmentsResult.length) {
      this.selection.selected.forEach(
        k => (this.bigBucket = this.bigBucket.filter(l => l.id !== k.id))
      );
      this.selection.clear();
    } else {
      this.shipmentsResult.forEach(row => {
        if (!this.selection.isSelected(row)) {
          this.selection.select(row);
          this.bigBucket.push({ ...row });
        }
      });
    }
  }

  restoreSelection() {
    this.shipmentsResult.forEach(sh => {
      if (this.bigBucket.filter(it => it.id === sh.id).length > 0) {
        this.selection.select(sh);
      }
    });
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.shipmentsResult.length;
    return numSelected === numRows;
  }

  selectAllByStatus(st: string) {
    if (this.selection.selected.filter(obj => obj._status === st).length > 0) {
      const tmp = this.selection.selected.filter(obj => obj._status !== st);
      const tr = this.selection.selected.filter(obj => obj._status === st);
      tr.forEach(
        atr => (this.bigBucket = this.bigBucket.filter(k => k.id !== atr.id))
      );
      this.selection.clear();
      tmp.forEach(row => this.selection.select(row));
    } else {
      this.shipmentsResult
        .filter(obj => obj._status === st)
        .forEach(row => {
          this.selection.select(row);
          this.bigBucket.push({ ...row });
        });
    }
  }

  s2ab(s: any): any {
    const buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    const view = new Uint8Array(buf); //create uint8array as viewer
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
    return buf;
  }

  liquidate() {
    Promise.all([
      this.createCodXLS(true),
      this.createChargesXLS(true),
      this.createReceipt(true),
    ]).then(res => {
      const formData = new FormData();
      formData.append('cod_xls', res[0].file);
      formData.append('charge_xls', res[1].file);
      formData.append('receipt_pdf', res[2].file);
      formData.append(
        'data',
        JSON.stringify({
          uid: this.fUsers[0].id,
          cod_ids: res[0].ids,
          charge_ids: res[1].ids,
          receipt_ids: res[2].ids,
          cod_sum: res[2].cod_sum,
          charge_sum: res[2].charge_sum,
          aaa: res[2].aaa,
        })
      );

      // Store files temporarily for download after API success
      if (this.sDl) {
        this.pendingLiquidationFiles = {
          codFile: res[0].file,
          chargesFile: res[1].file,
          receiptFile: res[2].file,
          user: this.fUsers[0],
        };
      }

      this.store.dispatch(new Liquidate({ fdata: formData }));
    });
  }

  private onLiquidationSuccess() {
    if (this.pendingLiquidationFiles) {
      const { codFile, chargesFile, receiptFile, user } =
        this.pendingLiquidationFiles;

      saveAs(
        codFile,
        `${user.id}_${user.kap} ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.xlsx`
      );
      saveAs(
        chargesFile,
        `${user.id}_${user.kap} ΑΝΑΛΥΣΗ ΧΡΕΩΣΕΩΝ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.xlsx`
      );
      saveAs(
        receiptFile,
        `${user.id}_${user.kap} ΑΠΟΔΕΙΞΗ ΕΙΣΠΡΑΞΗΣ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.pdf`
      );

      this.pendingLiquidationFiles = null;
    }

    // Clear extra charges only on successful liquidation
    this.clearExtraCharges();
  }

  private onLiquidationFailed() {
    // Clear pending files on failure - don't download
    this.pendingLiquidationFiles = null;
  }

  stateDl(event) {
    this.sDl = event.source._checked;
  }

  private guid() {
    const uniqueId =
      Math.random().toString(36).substring(2) +
      new Date().getTime().toString(36);
    return uniqueId;
  }
}
